import * as queries from './queries';
import app from '../../app';

export async function getScenarios({dispatch}) {
    return app.apolloClient
        .query({
            query: queries.scenariosQuery,
        })
        .then((result) => {
            return result.data.scenarios;
        })
}

export async function loadScenarioIntoPatient({dispatch}, {subjectId, scenarioKey}) {
    return app.apolloClient
        .mutate({
            mutation: queries.loadScenarioIntoPatientMutation,
            variables: {subjectId, scenarioKey},
        })
        .then((result) => {
            if (result.errors) {
                result.errors.forEach((error) => {
                    dispatch('error/submit', error, {root: true});
                });
            }
            /* patient id of new patient*/
            return result.data.loadScenario;
        }).catch((error) => {
            dispatch('error/submit', error, {root: true});
        })
}